import {
  ApplicationConfig,
  ErrorHandler,
  provideBrowserGlobalErrorListeners,
  importProvidersFrom,
  provideZonelessChangeDetection, isDevMode,
} from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideRouter, withPreloading, RouteReuseStrategy } from '@angular/router';

import { routes } from './app.routes';
import { AppRouteReuseStrategy } from './core/strategies/route-reuse.strategy';
import { SelectivePreloadingStrategy } from './core/strategies/selective-preloading.strategy';
import { GlobalErrorHandler } from './core/services/global-error-handler.service';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { CacheInterceptor } from './core/interceptors/cache.interceptor';
import { provideServiceWorker } from '@angular/service-worker';
import { BuupassAuthModule } from '@buupass/auth';
import { environment } from '@environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    importProvidersFrom(
      BuupassAuthModule.forRoot({
        apiKey: environment.apiKey,
        endpoints: {
          retrieveEmail: environment.userManagementApi.retrieveEmail,
          resetPassword: environment.userManagementApi.resetPassword,
          codePass: environment.userManagementApi.codePass,
          updateCodePass: environment.userManagementApi.updateCodePass,
          signUp: environment.userManagementApi.signUp,
          loginUser: environment.userManagementApi.loginUser,
          getProfile: environment.userManagementApi.getProfile,
          updateProfile: environment.userManagementApi.updateProfile
        }
      })
    ),
    provideRouter(
      routes,
      withPreloading(SelectivePreloadingStrategy)
    ),
    { provide: RouteReuseStrategy, useClass: AppRouteReuseStrategy },
    // Hydration is not needed without SSR; remove to avoid NG0505 warnings.
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheInterceptor,
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    }, provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
          })
  ],
};
